export default {
      id: "telegram-usage",
      viewBox: "0 0 24 20",
      url: __webpack_public_path__ + "assets/sprite.svg#telegram-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./assets/svg/telegram.svg
// module id = ./assets/svg/telegram.svg
// module chunks = 0